import { useContextLocalization } from "@/app/module/localization/index";
import { Text, TextProps } from "@/base/components/index";
import { useMemo } from "react";
export type LocalizationDatetimeProps = {
  value?: Date;
  dateStyle?: Intl.DateTimeFormatOptions["dateStyle"];
  timeStyle?: Intl.DateTimeFormatOptions["timeStyle"];
};

export const LocalizationDatetime = ({
  value,
  dateStyle = "medium",
  timeStyle = "medium",
  hasTextCmp = false,
  ...props
}: LocalizationDatetimeProps & TextProps & { hasTextCmp?: boolean }) => {
  const { currentLang } = useContextLocalization();
  const style = useMemo(() => ({ color: "inherit" }), []);

  if (!value) {
    return null;
  }

  const formattedValue = new Intl.DateTimeFormat(currentLang, {
    dateStyle: dateStyle,
    timeStyle: timeStyle,
  }).format(value);

  return hasTextCmp ? (
    <Text style={style} {...props}>
      {formattedValue}
    </Text>
  ) : (
    formattedValue
  );
};
